import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { Input, InputType, InputState, Label, Text, TextSize, TextColor, allowOnlyNumbers } from '@as/cotopaxi';
import { I18N_NAMESPACES } from '../../../constants/i18nConstants';
import { Box, Stack } from '@yonderland/andes-react';
const INPUT_ID = 'price-amount-input';
export const PriceAmount = ({ error, amount, currency, minAmount, maxAmount, onInputBlur, onAmountChange, }) => {
    const { t } = useTranslation([I18N_NAMESPACES.general, I18N_NAMESPACES.checkout]);
    return (_jsxs(Stack, { direction: "col", gap: "1", children: [_jsx(Label, { htmlFor: INPUT_ID, children: _jsx(Text, { emphasized: true, size: TextSize.SMALL, inline: true, children: t('general:gift.card.custom.amount', {
                        currency,
                        min: minAmount,
                        max: maxAmount,
                    }) }) }), _jsx(Box, { paddingInlineEnd: "16", children: _jsx(Input, { required: true, id: INPUT_ID, name: INPUT_ID, type: InputType.NUMBER, value: amount, min: Number(minAmount), max: Number(maxAmount), state: error && InputState.ERROR, onKeyDown: allowOnlyNumbers, onBlur: onInputBlur, onChange: onAmountChange, placeholder: `${currency}${minAmount} - ${currency}${maxAmount}` }) }), error && (_jsx(Text, { color: TextColor.NEGATIVE, size: TextSize.SMALL, inline: true, children: t(error, {
                    currency,
                    min: minAmount,
                    max: maxAmount,
                }) }))] }));
};
